import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";
import { map, shareReplay, switchMap } from "rxjs/operators";

import { dbToInt, dbToString } from "@dffedb/util";

import { Rolle } from "../bruger";
import { AktuelBrugerObserver } from "../bruger/aktuel-bruger.observer";
import { BrugerHttpClient } from "./../http/bruger-http-client.service";
import { Vej } from "./model/vej.model";

@Injectable({ providedIn: "root" })
export class VejService {
    constructor(private readonly aktuelBrugerObserver: AktuelBrugerObserver, private readonly brugerHttp: BrugerHttpClient) {}

    public hent(inkluderBlankVej: boolean): Observable<Vej[]> {
        return this.aktuelBrugerObserver.valueChanges.pipe(
            switchMap((bruger) => (Rolle.erForbruger(bruger.rolle) ? of({ veje: [] }) : this.brugerHttp.get("api/getveje"))),
            map((data) => this.map(data.veje)),
            map((veje) => veje.sort((a, b) => a.navn.localeCompare(b.navn))),
            // Vi fjerne alle blanke veje, da vi ikke kan bruge dem til så meget uden navn.
            map((veje) => veje.filter((v) => v.navn && v.navn.trim() !== "")),
            // Vi tilføjer eventuelt en enkelt blank vej, som kan bruge til at 'vælge alle' i listbokse.
            map((veje) => (inkluderBlankVej ? [{ id: 0, navn: "", postNr: "" }, ...veje] : veje)),
            shareReplay(1)
        );
    }

    private map(data: any[]): Vej[] {
        return data.map((d) => ({
            id: dbToInt(d.VEJNR),
            navn: dbToString(d.VEJNAVN),
            postNr: dbToString(d.POSTNR)
        }));
    }
}
